export async function GET({ url }) {
	const id = Number(url.searchParams.get('id'));

	const res = await fetch(
		`https://thumbnails.roblox.com/v1/users/avatar-headshot?userIds=${id}&size=150x150&format=Png`
	);

	return new Response(await res.text(), {
		status: res.status,
		headers: { 'Content-Type': 'application/json' }
	});
}
